var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-page-title'),_c('category-list',{model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}}),(_vm.allCourses)?_c('course-list',{attrs:{"courses":_vm.allCourses,"filters":_vm.filters}}):_vm._e(),_c('main-page-institute-list'),_c('faq-list'),_c('feedback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }